<div class="client-corner-map-bar">
  <div class="map-bar-content">
    <div class="map-bar-item">
      <button
        mat-flat-button
        class="new-project-button"
        [routerLink]="['/client-project', 'nieuw', '0']"
      >
        + Nieuwe bestelling
      </button>
    </div>
    <div class="map-bar-item left-space">
      <div class="d-flex">
        <mat-form-field class="address-search-input" appearance="outline">
          <input
            matInput
            placeholder="Straatnaam + nr"
            [(ngModel)]="addressLine1"
          />
        </mat-form-field>
        <mat-form-field
          class="address-search-input small-left-space"
          appearance="outline"
        >
          <input
            matInput
            placeholder="Postcode"
            [(ngModel)]="addressPostalCode"
          />
        </mat-form-field>
        <div class="map-bar-item">
          <button
            mat-flat-button
            class="search-button left-space"
            [disabled]="
              addressLine1?.length < 1 && addressPostalCode?.length < 1
            "
            (click)="searchOnAddress()"
          >
            Zoek
          </button>
        </div>
      </div>
    </div>
    <div class="map-bar-item left-space">
      <mat-radio-group
        [value]="selectedFilterType"
        (change)="selectedFilterTypeChanged($event.value)"
      >
        <mat-radio-button
          [value]="PROJECT_CLIENT_MAP_FILTER_TYPE.ALL"
          [checked]="selectedFilterType === PROJECT_CLIENT_MAP_FILTER_TYPE.ALL"
        >
          Alle opdrachten
        </mat-radio-button>
        <mat-radio-button
          class="left-space"
          [value]="PROJECT_CLIENT_MAP_FILTER_TYPE.AT_LEAST_ONE_ONGOING"
          [checked]="
            selectedFilterType ===
            PROJECT_CLIENT_MAP_FILTER_TYPE.AT_LEAST_ONE_ONGOING
          "
        >
          Lopende opdrachten
        </mat-radio-button>
        <mat-radio-button
          class="left-space"
          [value]="PROJECT_CLIENT_MAP_FILTER_TYPE.SOLD_RENTED"
          [checked]="
            selectedFilterType === PROJECT_CLIENT_MAP_FILTER_TYPE.SOLD_RENTED
          "
        >
          Verkocht / Verhuurd
        </mat-radio-button>
      </mat-radio-group>
    </div>
    <div class="map-bar-item flexer">
      <div class="marker-icons">
        <img
          *ngIf="
            selectedFilterType == null ||
            selectedFilterType === PROJECT_CLIENT_MAP_FILTER_TYPE.ALL ||
            selectedFilterType ===
              PROJECT_CLIENT_MAP_FILTER_TYPE.AT_LEAST_ONE_ONGOING
          "
          src="../../../assets/markers/Grijs.png"
          width="28"
          height="38"
        />
        <img
          *ngIf="
            selectedFilterType == null ||
            selectedFilterType === PROJECT_CLIENT_MAP_FILTER_TYPE.ALL
          "
          src="../../../assets/markers/Groen.png"
          width="28"
          height="38"
        />
        <img
          *ngIf="
            selectedFilterType == null ||
            selectedFilterType === PROJECT_CLIENT_MAP_FILTER_TYPE.ALL ||
            selectedFilterType ===
              PROJECT_CLIENT_MAP_FILTER_TYPE.AT_LEAST_ONE_ONGOING
          "
          src="../../../assets/markers/Blauw.png"
          width="28"
          height="38"
        />
        <img src="../../../assets/markers/Geel.png" width="28" height="38" />
        <img
          *ngIf="
            selectedFilterType == null ||
            selectedFilterType === PROJECT_CLIENT_MAP_FILTER_TYPE.ALL ||
            selectedFilterType ===
              PROJECT_CLIENT_MAP_FILTER_TYPE.AT_LEAST_ONE_ONGOING
          "
          src="../../../assets/markers/Rood.png"
          width="28"
          height="38"
        />
      </div>
    </div>
  </div>
</div>
<div>
  <div *ngIf="!init" class="table-loader-overlay overlay-top">
    <div style="margin-top: 200px; align-self: center">
      <mat-spinner
        style="margin: auto"
        color="primary"
        diameter="75"
      ></mat-spinner>
    </div>
  </div>
  <map-view
    [latitude]="INPRESS_COORDINATES.lat"
    [longitude]="INPRESS_COORDINATES.lng"
    [zoom]="14"
    [maxZoom]="19"
    [scrollwheel]="true"
    [fitBounds]="projectGroups != null && projectGroups.length > 0"
    [styles]="HIDE_POI_STYLE"
    (mapClick)="mapClick()"
  >
    <map-marker
      [latitude]="INPRESS_COORDINATES.lat"
      [longitude]="INPRESS_COORDINATES.lng"
      [iconUrl]="'../../../favicon.ico'"
    ></map-marker>
    <map-marker
      *ngFor="let projectGroup of projectGroups"
      [latitude]="projectGroup.lat"
      [longitude]="projectGroup.lng"
      [iconUrl]="{
        url: '../../../assets/markers/' + projectGroup.markerColor
      }"
      [openInfoWindow]="true"
      [mapFitBounds]="init"
      (markerClick)="markerClick(infoWindow)"
    >
      <map-info-window #infoWindow>
        <client-corner-marker-popup
          [projects]="projectGroup.projects"
        ></client-corner-marker-popup>
      </map-info-window>
    </map-marker>
  </map-view>
</div>
